export const types = {
  SET_LINK_LANDING_PAGES: "SET_LINK_LANDING_PAGES",
  ADD_LINK_LANDING_PAGE: "ADD_LINK_LANDING_PAGE",
  UPDATE_LINK_LANDING_PAGE: "UPDATE_LINK_LANDING_PAGE",
  DELETE_LINK_LANDING_PAGE: "DELETE_LINK_LANDING_PAGE",
};

export const setLinkLandingPages = payload => ({
  type: types.SET_LINK_LANDING_PAGES,
  payload,
});

export const addLinkLandingPage = payload => ({
  type: types.ADD_LINK_LANDING_PAGE,
  payload,
});

export const updateLinkLandingPage = payload => ({
  type: types.UPDATE_LINK_LANDING_PAGE,
  payload,
});

export const deleteLinkLandingPage = payload => ({
  type: types.DELETE_LINK_LANDING_PAGE,
  payload,
});
